import differenceBy from 'lodash/differenceBy';

import { InitialFormValues } from './DateTracking';

type DateTrackingItem = { id?: number; date?: string; reason?: string };

const mergeDateTrackingValues = (
  initialFormValues: DateTrackingItem[],
  formValues: DateTrackingItem[],
) => {
  const retainedItems = initialFormValues.filter((prev) =>
    formValues.some(
      (curr) => curr.date === prev.date && curr.reason === prev.reason,
    ),
  );
  const newItems = differenceBy(
    formValues,
    retainedItems,
    (item) => `${item.date}|${item.reason}`,
  ).map((item) => ({
    ...item,
    id: typeof item.id === 'number' ? item.id : 0,
    reason: item.reason ? item.reason : '',
  }));
  return [...retainedItems, ...newItems].filter((item) => item.date);
};

export function formatNewDateTrackingValues(
  initialFormValues: InitialFormValues = {},
  formValues: any = {},
) {
  return {
    ...initialFormValues,
    cannotCloseBeforeDateTracking: mergeDateTrackingValues(
      initialFormValues.cannotCloseBeforeDateTracking ?? [],
      formValues.cannotCloseBeforeDateTracking ?? [],
    ),
    mustCloseByDateTracking: mergeDateTrackingValues(
      initialFormValues.mustCloseByDateTracking ?? [],
      formValues.mustCloseByDateTracking ?? [],
    ),
    estimatedClosingDate: formValues.estimatedClosingDate,
  };
}
